module.exports = __webpack_public_path__ + "static/media/hiw3.99cdc3de.svg";